
export default {
  i18nComponentKey: 'ReviewsNew.components.RewardTable',
  name: 'RewardTable',
  props: {
    rows: { type: Array, required: true },
    isRewardEligible: { type: Boolean, required: true }
  }
};
